import { Injectable } from '@angular/core';
import { LocalStorageService } from '@core/services/local-storage.service';

const STORAGE_KEY = '__USER__TOKEN__';

@Injectable({
    providedIn: 'root'
})
export class TokenService {

    localStorageService: LocalStorageService;

    constructor(
    ) {
        this.localStorageService = new LocalStorageService();
    }

    getToken(): string {
        return this.localStorageService.getItem(STORAGE_KEY) || '';
    }

    saveToken(token: string): void {
        this.localStorageService.setItem(STORAGE_KEY, token);
    }

    destroyToken(): void {
        this.localStorageService.removeItem(STORAGE_KEY);
    }

}
